import React from "react";

import "./style.scss";

/**
 * APP PRIMARY ICON CONTAINER
 * @param {Object} props
 * @param {string} props.id
 * @param {Element} props.icon
 * @param {Function} props.onClick
 * @param {String} props.className
 * @returns JSX.ELEMENT => ICON
 */
const AppIcon = React.memo((props) => {
  const iconClasses = `app-icon ${props.className}`;
  let customProps = {};
  if (props.id) customProps = { ...customProps, id: props.id };
  return (
    <figure onClick={props.onClick} className={iconClasses} {...customProps}>
      {props.icon}
    </figure>
  );
});

export default AppIcon;
